// extracted by mini-css-extract-plugin
module.exports = {"general_error":"_2RPYO","generalError":"_2RPYO"};